import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const rowLayoutDefaultVariants = {
  "gap": "md",
  "align": "center",
  "justify": "start",
  "wrap": true
}
const rowLayoutCompoundVariants = []

const rowLayoutSlotNames = [
  [
    "root",
    "row-layout__root"
  ]
]
const rowLayoutSlotFns = /* @__PURE__ */ rowLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, rowLayoutDefaultVariants, getSlotCompoundVariant(rowLayoutCompoundVariants, slotName))])

const rowLayoutFn = memo((props = {}) => {
  return Object.fromEntries(rowLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const rowLayoutVariantKeys = [
  "gap",
  "align",
  "justify",
  "wrap"
]
const getVariantProps = (variants) => ({ ...rowLayoutDefaultVariants, ...compact(variants) })

export const rowLayout = /* @__PURE__ */ Object.assign(rowLayoutFn, {
  __recipe__: false,
  __name__: 'rowLayout',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: rowLayoutVariantKeys,
  variantMap: {
  "gap": [
    "none",
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "align": [
    "start",
    "center",
    "end",
    "baseline",
    "stretch"
  ],
  "justify": [
    "start",
    "center",
    "end",
    "between"
  ],
  "wrap": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, rowLayoutVariantKeys)
  },
  getVariantProps
})